<template>
  <div>
    <div class="modal fade" id="modalEditCompany" role="dialog">
      <div class="modal-dialog modal-dialog-centered inter-font">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Edit Company Info</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal" @click="resetField" >
              &times;
            </button>
          </div>
          <div class="modal-body container-body">
            <div class="row align-items-start">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label class="mb-0">Name</label>
                <p class="mb-0">:</p>
              </div>
              <div class="col-8 pl-1">
                <input
                  type="text"
                  name=""
                  v-model="companyInfo.name"
                  @blur="$v.companyInfo.name.$touch()"
                  class="form-control flex-grow-1 mb-0"
                  :style="
                    $v.companyInfo.name.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                />
                <p
                  v-if="$v.companyInfo.name.$error"
                  class="text-danger mb-0 mb-0"
                  style="font-size: 12px"
                >
                  Name must be filled
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-1">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>Company Name (NPWP)</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <div class="d-flex align-items-center w-100">
                  <input
                    type="text"
                    name="companyNameNPWP"
                    min="16"
                    max="16"
                    v-model="companyInfo.companyNameNPWP"
                    @blur="$v.companyInfo.companyNameNPWP.$touch()"
                    class="form-control flex-grow-1"
                    :style="
                      $v.companyInfo.companyNameNPWP.$error
                        ? 'border: 1px solid red; border-radius:5px'
                        : ''
                    "
                  />
                </div>
                <p
                  v-if="$v.companyInfo.companyNameNPWP.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Company Name (NPWP) must be filled
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>Province</label>
                <p class="mb-0">:</p>
              </div>
              <div class="col-8 pl-1">
                <multiselect
                  v-model="companyInfo.province"
                  :options="provinceOptions"
                  label="provinceName"
                  track-by="provinceName"
                  :allow-empty="false"
                  deselect-label="Can't remove this value"
                  @select="$v.companyInfo.province.$touch()"
                  @input="getKabkot(true)"
                  :style="
                    $v.companyInfo.province.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                ></multiselect>
                <p
                  v-if="$v.companyInfo.province.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Province must be filled
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>City</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <multiselect
                  v-model="companyInfo.regency"
                  :options="regencyOptions"
                  label="kabKotName"
                  track-by="kabKotName"
                  :allow-empty="false"
                  deselect-label="Can't remove this value"
                  @select="$v.companyInfo.regency.$touch()"
                  @input="getKecamatan(true)"
                  :style="
                    $v.companyInfo.regency.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                ></multiselect>
                <p
                  v-if="$v.companyInfo.regency.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  City must be filled
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-1">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>District</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <multiselect
                  v-model="companyInfo.district"
                  :options="districtOptions"
                  @select="$v.companyInfo.district.$touch()"
                  label="kecamatanName"
                  track-by="kecamatanName"
                  :allow-empty="false"
                  deselect-label="Can't remove this value"
                  :style="
                    $v.companyInfo.district.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                ></multiselect>
                <p
                  v-if="$v.companyInfo.district.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  District must be filled
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-1">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>Village</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <input
                  type="text"
                  name=""
                  v-model="companyInfo.village"
                  class="form-control flex-grow-1"
                  @blur="$v.companyInfo.village.$touch()"
                  :style="
                    $v.companyInfo.village.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                />
                <p
                  v-if="$v.companyInfo.village.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Village must be filled
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-1">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>Zip Code</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <input
                  type="text"
                  name=""
                  @blur="$v.companyInfo.zip.$touch()"
                  v-model="companyInfo.zip"
                  class="form-control flex-grow-1"
                  @keypress="isNumber($event)"
                  :style="
                    $v.companyInfo.zip.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                />
                <p
                  v-if="$v.companyInfo.zip.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Zip must be filled and maximum 5 digits number
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-1">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>Address</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <textarea
                  class="form-control"
                  rows="5"
                  v-model="companyInfo.address"
                  style="resize: none"
                  @blur="$v.companyInfo.address.$touch()"
                  :style="
                    $v.companyInfo.address.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                >
                </textarea>
                <p
                  v-if="$v.companyInfo.address.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Address must be filled
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-3">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>Akta Address</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <textarea
                  class="form-control"
                  rows="5"
                  @blur="$v.companyInfo.aktaAddress.$touch()"
                  v-model="companyInfo.aktaAddress"
                  style="resize: none"
                  :style="
                    $v.companyInfo.aktaAddress.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                >
                </textarea>
                <p
                  v-if="$v.companyInfo.aktaAddress.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Akta Address must be filled
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-3">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>Citizenship</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <multiselect
                  v-model="companyInfo.citizenship"
                  :options="[{label:'WNA', value: 'wna'}, {label:'WNI', value: 'wni'}]"
                  label="label"
                  track-by="value"
                  placeholder="Choose Citizenship"
                  @select="handleSelectCitizenship"
                  :allow-empty="false"
                  deselect-label="Can't remove this value"
                  :style="
                    $v.companyInfo.citizenship.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                ></multiselect>
                <p
                  v-if="$v.companyInfo.citizenship.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Citizenship must be filled
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label v-if="companyInfo.citizenship.value == 'wna'" >No. Passport</label>
                <label v-else >KTP Director</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <input
                  type="text"
                  name="ktp"
                  @input="handleChangeKTPOrPassport"
                  v-model="companyInfo.userKTPOrPassport"
                  class="form-control flex-grow-1"
                  @keypress="companyInfo.citizenship.value == 'wna'?undefined:isNumber($event)"
                  :style="
                    errorInputKtpOrPassport
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                />
                <p
                  v-if="errorInputKtpOrPassport"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  {{companyInfo.citizenship.value == 'wna'? 'No. Passport': 'KTP Director'}} must be filled {{ companyInfo.citizenship.value == 'wni'? 'and has 16 digits number': ''}}
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-1">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>NPWP</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <div class="d-flex align-items-center w-100">
                  <input
                    type="text"
                    name="npwp16"
                    placeholder="0123456789012345 "
                    min="16"
                    max="16"
                    v-model="companyInfo.npwpNumber16"
                    @blur="$v.companyInfo.npwpNumber16.$touch()"
                    class="form-control flex-grow-1"
                    @keypress="isNumber($event)"
                    :style="
                      $v.companyInfo.npwpNumber16.$error
                        ? 'border: 1px solid red; border-radius:5px'
                        : ''
                    "
                  />
                </div>
                <p
                  v-if="$v.companyInfo.npwpNumber16.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  NPWP must be filled and has 16 digits number
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-1">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>NITKU (Jika Ada)</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <div class="d-flex align-items-center w-100">
                  <input
                    type="text"
                    name="npwp"
                    placeholder="01213456789012345000000"
                    min="22"
                    max="22"
                    v-model="companyInfo.npwpNumber22"
                    @blur="$v.companyInfo.npwpNumber22.$touch()"
                    class="form-control flex-grow-1"
                    @keypress="isNumber($event)"
                    :style="
                      $v.companyInfo.npwpNumber22.$error
                        ? 'border: 1px solid red; border-radius:5px'
                        : ''
                    "
                  />
                </div>
                <p
                  v-if="$v.companyInfo.npwpNumber22.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  NITKU must have 22 digits number
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-1">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>Phone</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <input
                  type="text"
                  name="qty"
                  class="form-control flex-grow-1"
                  @blur="$v.companyInfo.phone.$touch()"
                  v-model="companyInfo.phone"
                  @keypress="isNumber($event)"
                  :style="
                    $v.companyInfo.phone.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                />
                <p
                  v-if="$v.companyInfo.phone.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Phone must be filled
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-1">
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>Source</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <multiselect
                  v-model="companyInfo.source"
                  :options="sourceOptions"
                  :allow-empty="false"
                  :select-label="''"
                  :deselect-label="''"
                  @blur="$v.companyInfo.source.$touch()"
                  placeholder="Source"
                  :style="
                    $v.companyInfo.source.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                ></multiselect>
                <p
                  v-if="$v.companyInfo.source.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Source must be filled
                </p>
              </div>
            </div>
            <div
              v-if="companyInfo.source == 'Other'"
              class="row align-items-start mt-1"
            >
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label>New Source</label>
                <p>:</p>
              </div>
              <div class="col-8 pl-1">
                <input
                  type="text"
                  name="new_source"
                  class="form-control"
                  v-model="companyInfo.newSource"
                  @blur="$v.companyInfo.newSource.$touch()"
                  :style="
                    $v.companyInfo.newSource.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                />
                <p
                  v-if="$v.companyInfo.newSource.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  New source must be filled
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
              @click="resetField"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitEditCompany"
              v-if="isLoadingSubmit == false"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  requiredIf,
} from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  components: {
    Multiselect,
  },
  props: {
    lesseeData: {
      type: Object,
      required: true,
    },
    triggerOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      adminId: "",
      isLoadingSubmit: false,
      provinceOptions: [],
      districtOptions: [],
      regencyOptions: [],
      sourceOptions: [],
      isLoadingSubmit: false,
      errorInputKtpOrPassport: false,
      companyInfo: {
        name: null,
        companyNameNPWP: null,
        address: null,
        province: null,
        regency: null,
        district: null,
        village: null,
        zip: null,
        aktaAddress: null,
        phone: null,
        userKTPOrPassport: null,
        source: null,
        npwpNumber16: null,
        npwpNumber22: null,
        newSource: null,
        citizenship: {
          label: null,
          value: null,
        },
      },
    };
  },
  validations: {
    companyInfo: {
      name: {
        required,
      },
      companyNameNPWP: {
        required,
      },
      address: {
        required,
        minLength: minLength(3),
      },
      province: {
        required,
      },
      citizenship: {
        required,
      },
      regency: {
        required,
      },
      district: {
        required,
      },
      village: {
        required,
      },
      zip: {
        required,
        maxLength: maxLength(5),
      },
      aktaAddress: {
        required,
      },
      npwpNumber16: {
        required,
        minLength: minLength(16),
        maxLength: maxLength(16),
      },
      npwpNumber22: {
        minLength: minLength(22),
        maxLength: maxLength(22),
      },
      phone: {
        required,
      },
      source: {
        required,
      },
      newSource: {
        required: requiredIf(function () {
          return (
            this.companyInfo.source == "Other" && !this.companyInfo.newSource
          );
        }),
      },
    },
  },
  watch: {
    lesseeData(val) {
      if (val && val.detailLessee.length > 0) {
        this.setInitialData(val);
      };
      
    },
    triggerOpen() {
      $("#modalEditCompany").modal("show");
    },
  },
  methods: {
    handleSelectCitizenship() {
      this.$v.companyInfo.citizenship.$touch()
      this.errorInputKtpOrPassport = false
      this.companyInfo.userKTPOrPassport = null;
    },
    handleChangeKTPOrPassport(e){
      const value = e.target.value;
      this.validateInputKtpOrPassport(value);
    },
    validateInputKtpOrPassport(value) {
      if (!value) {
        this.errorInputKtpOrPassport = true
        return;
      }
      if (this.companyInfo.citizenship.value == "wni") {
        if (value.length != 16) {
          this.errorInputKtpOrPassport = true;
        } else {
          this.errorInputKtpOrPassport = false;
        }
      } else {
        this.errorInputKtpOrPassport = false;
      }
    },
    setInitialData(companyInfo) {
      const lesseeData = companyInfo.detailLessee[0];
      console.log("lesseeData", lesseeData);

      this.companyInfo = {
        name: lesseeData.companyName,
        companyNameNPWP: lesseeData.companyNameNPWP,
        address: lesseeData.companyAddress,
        province: companyInfo.province[0],
        regency: companyInfo.kabkot[0],
        district: companyInfo.kecamatan[0],
        village: lesseeData.companyKelurahan,
        zip: lesseeData.companyZip,
        aktaAddress: lesseeData.aktaAddress,
        phone: lesseeData.companyPhone,
        userKTPOrPassport: lesseeData.companyKtpPassportNumber,
        source: lesseeData.source,
        npwpNumber16: lesseeData.companyNPWP16,
        npwpNumber22: lesseeData.companyNPWP22,
        citizenship: {
          label: lesseeData.citizenship.toUpperCase(),
          value: lesseeData.citizenship,
        },
      };

      if(companyInfo.province[0]) {
        this.getKabkot(false)
      }

      if(companyInfo.kabkot[0]) {
        this.getKecamatan(false)
      }
    },
    resetField() {
      this.setInitialData(this.lesseeData);
      this.$v.$reset();
      this.errorInputKtpOrPassport = false
    },
    submitEditCompany() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      this.validateInputKtpOrPassport(this.companyInfo.userKTPOrPassport);
      if (!isValid || this.errorInputKtpOrPassport) {
        swal("Field Error", "Please check all error field", "error");
        return;
      }
      const sentData = {
        companyId: Number(this.lesseeData.detailLessee[0].companyId),
        companyNameNPWP: this.companyInfo.companyNameNPWP.replace(
          this.spaceRegex,
          " "
        ),
        companyName: this.companyInfo.name.replace(this.spaceRegex, " "),
        province: this.companyInfo.province.provinceName,
        kabkot: this.companyInfo.regency.kabKotName,
        kecamatan: this.companyInfo.district.kecamatanName,
        kelurahan: this.companyInfo.village.replace(this.spaceRegex, " "),
        zipCode: this.companyInfo.zip.replace(this.spaceRegex, " "),
        companyAddress: this.companyInfo.address.replace(this.spaceRegex, " "),
        aktaAddress: this.companyInfo.aktaAddress.replace(this.spaceRegex, " "),
        phoneNumber: this.companyInfo.phone.replace(this.spaceRegex, " "),
        KTPpassport: this.companyInfo.userKTPOrPassport.replace(this.spaceRegex, " "),
        citizenship: this.companyInfo.citizenship.value,
        npwpNumber16: this.companyInfo.npwpNumber16.replace(
          this.spaceRegex,
          " "
        ),
        npwpNumber22: this.companyInfo.npwpNumber22.replace(
          this.spaceRegex,
          " "
        ),
        source:
          this.companyInfo.source === "Other"
            ? this.companyInfo.newSource.replace(this.spaceRegex, " ")
            : this.companyInfo.source,
        adminId: this.adminId,
        newCompany: this.lesseeData.newCompany,
      };
      this.isLoadingSubmit = true;
      this.$http
        .post(process.env.EDIT_LESSEE, sentData, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          let sendLogData = {
            w: [],
            x: this.lesseeData.detailLessee[0].companyId,
            y: "company",
          };
          if (response.data.status === 200) {
            swal("Success", response.data.message, "success", {
              button: "Ok",
            });
            if (response.data.data.newName) {
              sendLogData.w.push(58);
            }
            if (response.data.data.newArea) {
              sendLogData.w.push(47);
            }
            if (response.data.data.newPhone) {
              sendLogData.w.push(51);
            }
            if (response.data.data.newSource) {
              sendLogData.w.push(52);
            }
            if (response.data.data.newAddress) {
              sendLogData.w.push(48);
            }
            if (response.data.data.newAktaAddress) {
              sendLogData.w.push(50);
            }
            if (response.data.data.newKtpPassport) {
              sendLogData.w.push(177);
            }
            if (response.data.data.newCitizenship) {
              sendLogData.w.push(178);
            }
            this.isLoadingSubmit = false;
          } else  {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
            this.handleLogout();
          }
          $("#modalEditCompany").modal("hide");
          this.isLoadingSubmit = false;
          this.$emit("success-edit-company", sendLogData);
        })
        .catch((error) => {
          this.isLoadingSubmit = false;
          if (error.response.status) {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            });
          } else {
            swal("Error", error.message, "error");
          }
        });
    },
    getProvince() {
      this.$http
        .get(process.env.API_GET_PROVINCE, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.provinceOptions = response.data.content;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getKabkot(reset) {
      this.$http
        .post(
          process.env.API_GET_KABKOT,
          {
            provinceId: this.companyInfo.province.provinceId,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.regencyOptions = response.data.content;
            if(reset) {
              this.companyInfo = {
                ...this.companyInfo,
                regency: null,
                district: null,
                village: null,
                zip: null,
                address: null,
              };
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getLesseeSource() {
      this.$http
        .get(process.env.GET_LESSEE_SOURCE, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
            this.handleLogout();
          } else {
            this.sourceOptions = response.data.data.map(el=> el.sourceName);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getKecamatan(reset) {
      this.$http
        .post(
          process.env.API_GET_KECAMATAN,
          {
            kabKotId: this.companyInfo.regency.kabKotId,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.districtOptions = response.data.content;
            if(reset) {
              this.companyInfo = {
                ...this.companyInfo,
                district: null,
                village: null,
                zip: null,
                address: null,
              };
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.getProvince();
    this.getLesseeSource();
    this.adminId = localStorage.getItem("admin_id");
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

.inter-font {
  font-family: "Inter", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

.container-body {
  max-height: 70vh;
  overflow-y: auto;
}

p,
label,
input,
textarea,
span,
.multiselect {
  color: #2e3646;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/Partnership/Component/ModalEditCompanyInfoLessee.vue